(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nv-catalog-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nv-catalog-header')) {
    customElements.define('nv-catalog-header', class extends HTMLElement {
      connectedCallback() {
        this.preserveFilters = this.preserveFilters.bind(this);
        this.addEventListener('click', this.preserveFilters);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.preserveFilters);
      }
      preserveFilters(event) {
        const link = event.target.closest('a[data-nv-category]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = new URL(link.href, window.location.origin);
        const query = new URLSearchParams(window.location.search);
        query.delete('page');
        query.delete('section_id');
        query.delete('sections');
        url.search = query.toString();
        link.href = url.toString();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
